<template>
    <div>
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance / Geo Locations</span>
        </h4>
        <div class="clearfix company-form-container rounded mt-4 pb-5 mx-auto px-3 ibox">

            <div class="clearfix row py-2 mb-2">
                <div class="col-sm-5 px-3 company-form-box-title">Geo Locations</div>
                <div class="col-sm-4">
                    <div class="custom-search float-right w-100">
                        <b-input-group class="mb-0">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
                <div class=" col-sm-3 text-right pr-0">
                    <b-button id="show-btn" class="mr-3" v-if="permission >= 2" @click="addNew()"> Add Geo Location</b-button>
                </div>
            </div>


            <div class="row justify-content-center">
                <div class="col-sm-12  px-0" v-if="permission == 2">
                    <!-- Abdullah after live added this -->
                    <b-modal id="bv-modal-geolocation" size="lg" hide-footer :title="geo_location_title">
                        <b-overlay  rounded="sm">

                            <b-form @submit.stop.prevent="onSubmit" class="">
                                <input type="hidden" v-model="fdata.id" name="id">
                                <div class="clearfix row">


                                    <div class="col-md-6">
                                        <b-form-group id="name-group" label="Name" class="required-field" label-for="name" :style="(veeErrors.has('lat') && !veeErrors.has('name')) ? 'margin-bottom: 39px' : ''">
                                            <b-input-group>
                                                <b-form-input id="name" class="radius-8" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>


                                        <b-form-group id="lng-group" label="Longitude" class="required-field" label-for="lng" >
                                            <b-input-group>
                                                <b-form-input id="lng" class="radius-8" name="lng" v-model="fdata.lng" v-validate="{ required: true, min: 3 }" :state="validateState('lng')" aria-describedby="lng-feedback" data-vv-as="Longitude"></b-form-input>
                                                <b-form-invalid-feedback id="lng-feedback">{{ veeErrors.first('lng') }}</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>

                                    </div>

                                    <div class="col-md-6">
                                        <b-form-group id="lat-group" label="Latitude" class="required-field" label-for="lat" :style="(veeErrors.has('lat') && !veeErrors.has('name')) ? 'margin-bottom: 39px' : ''">
                                            <b-input-group>
                                                <b-form-input id="lat" class="radius-8" name="lat" v-model="fdata.lat" v-validate="{ required: true, min: 3 }" :state="validateState('lat')" aria-describedby="lat-feedback" data-vv-as="Latitude"></b-form-input>
                                                <b-form-invalid-feedback id="lat-feedback">{{ veeErrors.first('lat') }}</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>


                                    <div class="full-width btn-wrapper text-center pt-3">
                                        <!-- alpha fix- chnaged the btn name save to submit  -->
                                        <b-button type="submit" v-if="fdata.id" variant="primary" >Update</b-button>
                                        <b-button type="submit" v-else variant="primary" >Submit</b-button>
                                    </div>
                                </div>
                            </b-form>
                        </b-overlay>
                    </b-modal>

                </div>


                <div class="col-sm-12 px-3" v-if="permission >= 0">
                    <b-overlay :show="showoverlay" rounded="sm">
                        <table class="table list-tables">
                            <thead>
                                <tr class="table-head">
                                    <td class="pl-5">#</td>
                                    <td>Name</td>
                                    <td>Latitude</td>
                                    <td>Longitude</td>
                                    <td v-if="permission >= 2" class="">Action</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2" v-for="(geolocation , n) in paginatedData" :key="geolocation.id">
                                    <td class="pl-5">{{n+1}}</td>
                                    <td class=" ">{{geolocation.name}}</td>
                                    <td class=" ">{{geolocation.lat}}</td>
                                    <td class=" ">{{geolocation.lng}}</td>



                                    <td class="float-right" v-if="permission >= 2">
                                        <div class="float-right mr-2 position-relative">
                                            <b-button-toolbar>
                                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                    <b-button-group class="mr-0">
                                                        <b-button class="mr-3 rounded edit-btn text-left" title="Edit Geo Location" @click="editGeoLocation(geolocation.id)">
                                                            <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                        </b-button>
                                                        <b-button v-if="permission == 2" class="rounded delete-btn text-left" title="Delete Geo Location" @click="deleteGeoLocation(geolocation.id)">
                                                            <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                        <div v-else class="px-3">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                            </ul>
                            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" first-number last-number ><template #prev-text><span>Previous</span></template><template #next-text><span>Next</span></template></b-pagination-nav>
                        </div>

                    </b-overlay>
                </div>

            </div>

        </div>
    </div>
</template>
<script>
    export default{

        mounted() {
            //this.permission = this.$acl['geolocation/details'];
        },
        props: ['flg'],
        data(){

            return {

                geolocations : [],


                successmsg:false,
                warningmsg:false,
                dangermsg:false,

                showoverlay:false,

                errormsg:[],
                fdata: { id:null , name:'' , lat:'' , lng:''},


                search:'',
                length: 20,
                temp_length:20,
                people:0,
                length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
                pagination: {currentPage: 1, pages:1},

                permission : 2,

                no_geolocations: 'N/A',

                // Abdullah after live added this
                geo_location_title: 'Add Geo Location',


            }
        },
        methods:{

            getGeoLocationData: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/geolocation/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.geolocations = response.data;
                    this.people = response.data.length;

                    //this.showMessage();
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            editGeoLocation: function(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                this.warningmsg = null;
                this.successmsg = null;
                //this.showMessage();

                //this.showoverlay = true;
                // Abdullah after live adeed this
                this.geo_location_title = 'Edit Geo Location';
                axios.get(this.$api_url+'/geolocation/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;



                    this.$validator.reset();
                    this.successmsg = null;
                    //this.showoverlay = false;

                    this.$bvModal.show('bv-modal-geolocation');

                }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});

            },
            deleteGeoLocation(id) {
                    if(!this.checkNet()) return false;
                    let currentObj = this;

                    this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this geo location.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        this.resetForm();
                        this.warningmsg = null;
                        this.successmsg = null;

                        this.showoverlay = true;
                        let formData = new FormData();
                        formData.append('id', id);

                        axios.post(this.$api_url+'/geolocation/delete', formData).then(function(response){

                            if(response.data.status == true)
                            {
                                this.$bvToast.toast(response.data.meg, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                this.getGeoLocationData();

                            }
                            else
                            {
                                this.$bvToast.toast(response.data.meg, {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true
                                        });
                            }

                            this.resetPagination();
                            //this.showMessage();

                            this.showoverlay = false;

                        }.bind(this))
                        .catch(function (error)
                        {

                            currentObj.showoverlay = false;
                            currentObj.serverError(error);
                        });
                    }
                })
                ;
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
               this.fdata = {id:null , name:'' , division:'Dhaka' , district:null , address_line_1:'',address_line_2:'',city:'', postcode:''};


                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNew()
            {
                this.resetForm();
                // Abdullah after live added this
                this.geo_location_title = 'Add Geo Location';
                this.$bvModal.show('bv-modal-geolocation');
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.warningmsg = null;
                this.successmsg = null;
                //this.showMessage();

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlay = true;

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/geolocation/save', formData, config)
                        .then(function (response)
                        {
                            this.getGeoLocationData();


                            this.$bvToast.toast('Saved!', {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });


                            this.showoverlay = false;
                            this.resetForm();
                            //this.movenext = true;
                            //this.showMessage();

                            this.$bvModal.hide('bv-modal-geolocation');

                        }.bind(this))
                        .catch(function (error)
                        {

                            this.showoverlay = false;

                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                        });
                });
            },

        },
        created: function(){
            this.getGeoLocationData();
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.geolocations;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
